/**
 * Removes certain characters from a string for search
 * @param {string} value - the name of the property to treat as an id
 * @return {string} an array of ids
 */
export default function escapeRegExp(value: string): string {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '');
}